import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-warm-100" data-id="element-121">
      <div className="max-w-4xl mx-auto px-4" data-id="element-122">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-charcoal mb-12 leading-tight" data-id="element-123">
          ¿Tu Airfryer solo sirve para hacer papas congeladas porque{' '}
          <span className="text-primary" data-id="element-124">nada típico te queda bien?</span>
        </h2>

        <div className="bg-white rounded-2xl p-6 md:p-10 shadow-lg border border-warm-50 mb-10" data-id="element-125">
          <p className="text-lg text-charcoal leading-relaxed mb-8 font-medium italic" data-id="element-126">
            "¿Te ha pasado? Son las 6:30 PM. Llegas cansada del trabajo, el
            tráfico estuvo terrible y tienes un antojo inmenso de algo típico…
            pero pensar en la paila con aceite, el olor por tres días y lavar
            grasa pegada, te quita las ganas. Terminas en sándwich triste o en
            un domicilio caro que llega frío y 'cauchudo'."
          </p>

          <ul className="space-y-4 mb-8" data-id="element-127">
            {['Tu Airfryer está cogiendo polvo o solo la usas para calentar pan', 'La papa criolla se te arruga en vez de dorar', 'Te queda quemado por fuera y crudo por dentro', 'Cocinas y tu apartamento queda oliendo a fritanga'].map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-128">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-129" />
                <span className="text-charcoal-muted text-lg" data-id="element-130">{bullet}</span>
              </li>)}
          </ul>

          <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg mb-8" data-id="element-131">
            <p className="text-charcoal text-lg" data-id="element-132">
              El problema no es tu Airfryer. El problema es que estás usando{' '}
              <strong className="text-red-700" data-id="element-133">
                tiempos y potencias que no corresponden a las marcas y voltajes
              </strong>{' '}
              que usamos en Colombia. Y sin el paso final correcto,{' '}
              <strong className="text-red-700" data-id="element-134">
                nunca vas a lograr ese "crunch" real.
              </strong>
            </p>
          </div>

          <p className="text-xl text-center font-heading font-semibold text-charcoal" data-id="element-135">
            Si te reconoces, no es que "no sepas cocinar": es que nadie te dio{' '}
            <span className="text-primary" data-id="element-136">un sistema simple y repetible</span>{' '}
            para que te quede bien desde la primera.
          </p>
        </div>

        {/* Mini Box */}
        <div className="bg-charcoal text-white rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-137">
          <div className="flex items-center gap-3 mb-6 justify-center" data-id="element-138">
            <AlertTriangle className="w-6 h-6 text-accent" data-id="element-139" />
            <h3 className="text-xl font-heading font-bold text-center" data-id="element-140">
              Por qué lo típico falla
            </h3>
          </div>

          <ul className="space-y-4 max-w-2xl mx-auto" data-id="element-141">
            <li className="flex items-start gap-3" data-id="element-142">
              <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 shrink-0" data-id="element-143"></div>
              <span className="text-gray-300" data-id="element-144">
                Las recetas de YouTube usan potencias distintas a las de marcas
                comunes en Colombia
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-145">
              <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 shrink-0" data-id="element-146"></div>
              <span className="text-gray-300" data-id="element-147">
                Sin "golpe de calor" final, te queda blandito aunque "se vea
                dorado"
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-148">
              <div className="w-1.5 h-1.5 rounded-full bg-accent mt-2.5 shrink-0" data-id="element-149"></div>
              <span className="text-gray-300" data-id="element-150">
                Si amontonas, el aire no circula: se sancochan en vez de crocar
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}